<template>
    <div>
        <Notification v-if="! balances">
            Loading...
        </Notification>

        <Notification v-if="balances && ! balances.length">
            There are no outstanding payments on your account.
        </Notification>

        <div v-if="balances">
            <div
                v-for="row in balances"
                :key="row.TenancyFK"
            >
                <ContactArrearsNotification :row="row" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Notification from './Notification.vue';
import ContactArrearsNotification from './ContactArrearsNotification';

export default {
    components: {
        Notification,
        ContactArrearsNotification,
    },

    computed: {
        ...mapState('contactArrears', [
            'balances',
        ]),
    },

    mounted() {
        this.getArrears();
    },

    methods: {
        getArrears() {
            this.$store.dispatch('contactArrears/getBalances');
        },
    },
};
</script>
